var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "qs-action-modal",
    {
      attrs: {
        value: _vm.syncedValue,
        "content-class": "add-to-call-campaign-modal"
      },
      on: {
        "click:close": function($event) {
          _vm.syncedValue = false
        }
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c(
                "v-icon",
                { staticClass: "mr-2 qs-orange--text", attrs: { large: "" } },
                [_vm._v("mdi-hand-left")]
              ),
              _c("span", { staticClass: "white--text" }, [
                _vm._v("Ajouter un·e militant·e")
              ])
            ]
          },
          proxy: true
        },
        {
          key: "subtitle",
          fn: function() {
            return [_vm._v(" à une campagne d'appels ")]
          },
          proxy: true
        },
        {
          key: "actions",
          fn: function() {
            return [
              _c(
                "qs-button",
                {
                  attrs: {
                    color: "primary",
                    disabled: _vm.callCampaign === null,
                    loading: _vm.loading
                  },
                  on: { click: _vm.submit }
                },
                [_vm._v(" Ajouter ")]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("qs-relation-field", {
        ref: "relation",
        attrs: {
          item: _vm.dummyItem,
          label: "Recherche",
          name: "add_contacts_to_call_campaign",
          query: _vm.queryDefinition,
          value: _vm.callCampaign
        },
        on: {
          input: function($event) {
            _vm.callCampaign = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }